<template>
  <div class="go-mobile">
    <div class="header" id="header">
      <p class="header-title">{{ $t("RedteaGo.title") }}</p>
      <div class="flex-box">
        <img src="../assets/go-mobile/分组 9.png" />
        <span>{{ $t("RedteaGo.content1") }}</span>
      </div>
      <div class="flex-box">
        <span>{{ $t("RedteaGo.content2") }}</span>
        <img src="../assets/go-mobile/分组 10.png" />
      </div>
      <div class="flex-box">
        <img src="../assets/go-mobile/分组 11.png" />
        <span>{{ $t("RedteaGo.content3") }}</span>
      </div>
      <div class="flex-box">
        <span>{{ $t("RedteaGo.content4") }}</span>
        <img src="../assets/go-mobile/分组 12.png" />
      </div>
      <p class="content" style="margin-top: 0.5rem">
        {{ $t("RedteaGo.desShort") }}
      </p>
      <!--      <a href="https://app.redteago.com" target="blank">-->
      <!--        <p class="img-more">-->
      <!--          {{ $t("LEARN") }}&nbsp;&nbsp;-->
      <!--          <img src="../assets/go-mobile/跳转 (5).svg" style="width: 0.11rem" />-->
      <!--        </p>-->
      <!--      </a>-->
    </div>

    <div class="tech">
      <p class="tech-title">{{ $t("RedteaGo.Highlights.title") }}</p>
      <p class="content">- {{ $t("RedteaGo.Highlights.des") }}</p>
      <p class="content">- {{ $t("RedteaGo.Highlights.content1") }}</p>
      <p class="content">- {{ $t("RedteaGo.Highlights.content2") }}</p>
      <p class="content" style="margin-bottom: 0.4rem">
        - {{ $t("RedteaGo.Highlights.content3") }}
      </p>
      <Divider />
    </div>

    <div style="padding: 0 0.2rem" id="iosEsim">
      <div class="text-box">
        <p class="title">{{ $t("RedteaGo.phoneTitle") }}</p>
        <div class="img-box">
          <img src="../assets/go-mobile/get_mobile.png" style="width: 2.2rem" />
        </div>
        <p
          style="
            color: rgba(32, 49, 82, 1);
            font-family: 'Poppins-ExtraLight';
            font-size: 0.12rem;
            text-align: left;
            margin-bottom: 0.4rem;
            margin-top: 0.1rem;
          "
        >
          {{ $t("RedteaGo.phonetxt1") }}
          <a
            href="https://apps.apple.com/app/redteago/id1492864476"
            target="_blank"
            style="color: rgba(211, 36, 23, 1); text-decoration: underline"
            >{{ $t("RedteaGo.phonetxt2") }}</a
          >
          {{ $t("RedteaGo.phonetxt3") }}
        </p>
        <!--        <a href="https://www.redteago.com" target="blank">-->
        <!--          <p class="img-more">-->
        <!--            {{ $t("LEARN") }}&nbsp;&nbsp;>-->
        <!--            <img-->
        <!--              src="../assets/go-mobile/跳转 (5).svg"-->
        <!--              style="width: 0.11rem"-->
        <!--            />-->
        <!--          </p>-->
        <!--        </a>-->
      </div>
    </div>

    <div style="padding: 0 0.2rem">
      <Divider />
    </div>

    <div style="padding: 0 0.2rem" id="Pixel">
      <div class="text-box">
        <p class="title">{{ $t("RedteaGo.pTitle") }}</p>
        <div class="img-box">
          <img src="../assets/go-mobile/展示图2.png" style="width: 2.64rem" />
        </div>
        <p class="content">{{ $t("RedteaGo.pDes") }}</p>
        <!--        <a href="https://www.redteago.com/home/pixelesim.html" target="blank">-->
        <!--          <p class="img-more">-->
        <!--            {{ $t("LEARN") }}&nbsp;&nbsp;>-->
        <!--            <img-->
        <!--              src="../assets/go-mobile/跳转 (5).svg"-->
        <!--              style="width: 0.11rem"-->
        <!--            />-->
        <!--          </p>-->
        <!--        </a>-->
      </div>
    </div>

    <div style="padding: 0 0.2rem">
      <Divider />
    </div>

    <!--    <div style="padding: 0 0.2rem" id="iPhone">-->
    <!--      <div class="text-box">-->
    <!--        <p class="title">{{ $t("RedteaGo.iTitle") }}</p>-->
    <!--        <div class="img-box">-->
    <!--          <img src="../assets/go-mobile/1界面展示.png" style="width: 1.56rem" />-->
    <!--        </div>-->
    <!--        <p class="content">{{ $t("RedteaGo.iDes") }}</p>-->
    <!--        <a href="https://esim.redteago.com" target="blank">-->
    <!--          <p class="img-more">-->
    <!--            {{ $t("LEARN") }}&nbsp;&nbsp;>-->
    <!--            <img-->
    <!--              src="../assets/go-mobile/跳转 (5).svg"-->
    <!--              style="width: 0.11rem"-->
    <!--            />-->
    <!--          </p>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div style="padding: 0 0.2rem">-->
    <!--      <Divider />-->
    <!--    </div>-->

    <!--    <div style="padding:0 0.2rem;" id="SIMCard">-->
    <!--      <div class="text-box">-->
    <!--        <p class="title">{{$t('RedteaGo.sTitle')}}</p>-->
    <!--        <div class="img-box">-->
    <!--          <img src="../assets/go-mobile/实体卡.png" style="width:2.2rem;" />-->
    <!--        </div>-->
    <!--        <p class="content">{{$t('RedteaGo.sDes')}}</p>-->
    <!--        <p-->
    <!--          style="color: rgba(32, 49, 82, 1);font-family: 'Poppins-ExtraLight';font-size: 0.12rem;text-align: left;margin-bottom:0.4rem;margin-top:0.1rem;"-->
    <!--        >-->
    <!--          {{$t('RedteaGo.sDes0')}}-->
    <!--          <a-->
    <!--            href="mailto:communications@redteamobile.com"-->
    <!--            style="color:rgba(211, 36, 23, 1);text-decoration:underline"-->
    <!--          >communications@redteamobile.com</a>-->
    <!--          {{$t('RedteaGo.sDes1')}}-->
    <!--          <a-->
    <!--            href="https://sim.redteago.com/?lang=en"-->
    <!--            target="blank"-->
    <!--            style="color:rgba(211, 36, 23, 1);text-decoration:underline"-->
    <!--          >https://sim.redteago.com</a>-->
    <!--          {{$t('RedteaGo.sDes2')}}-->
    <!--        </p>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div style="padding:0 0.2rem;">-->
    <!--      <Divider />-->
    <!--    </div>-->

    <div style="padding: 0 0.2rem">
      <div class="text-box">
        <p class="title" id="Android">{{ $t("RedteaGo.anTitle") }}</p>
        <div class="img-box" style="margin-top: 0.1rem">
          <img src="../assets/go-mobile/品牌图.png" />
        </div>
        <p class="content">{{ $t("RedteaGo.anDes") }}</p>
        <!--        <a href="https://app.redteago.com/?lang=en" target="blank">-->
        <!--          <p class="img-more">-->
        <!--            {{ $t("LEARN") }}&nbsp;&nbsp;-->
        <!--            <img-->
        <!--              src="../assets/go-mobile/跳转 (5).svg"-->
        <!--              style="width: 0.11rem"-->
        <!--            />-->
        <!--          </p>-->
        <!--        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RedteaGo-mobile",
  components: {},
};
</script>
<style lang="less" scoped>
.go-mobile {
  .content {
    color: rgba(32, 49, 82, 1);
    font-family: "Poppins-ExtraLight";
    font-size: 0.12rem;
    text-align: left;
  }
  .title {
    color: rgba(32, 49, 82, 1);
    font-family: "Poppins-Light";
    font-size: 0.14rem;
    text-align: left;
  }
  .more {
    color: rgba(207, 42, 42, 1);
    font-family: "Poppins-Light";
    font-size: 0.14rem;
    text-align: left;
    text-decoration: underline;
    margin-top: 0.4rem;
  }
  .img-more {
    color: rgba(207, 42, 42, 1);
    font-family: "Poppins-Bold";
    font-size: 0.12rem;
    margin: 0.2rem 0 0.4rem 0;
  }
  .line {
    width: 100px;
    height: 1px;
    background: rgba(207, 42, 42, 1);
    opacity: 0.3;
    margin: 0.2rem 0;
  }
  .header {
    padding: 1.1rem 0.25rem 0.35rem 0.25rem;
    background: rgba(249, 249, 249, 1);
    .flex-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: -0.3rem;
      span {
        color: rgba(32, 49, 82, 1);
        font-family: "Poppins-ExtraLight";
        font-size: 0.12rem;
      }
    }
    .header-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Regular";
      font-size: 0.16rem;
      width: 3.25rem;
      margin: 0 auto 0.1rem auto;
    }
    img {
      width: 1.1rem;
    }
  }
  .tech {
    padding: 0.4rem 0.2rem 0 0.2rem;
    .tech-title {
      color: rgba(32, 49, 82, 1);
      font-family: "Poppins-Regular";
      font-size: 0.16rem;
      text-align: left;
      margin-bottom: 0.1rem;
    }
  }
}
</style>